import { ReactNode, useEffect, useReducer, useRef } from "react";

import { registerMemoryStatsProvider } from "utils/memoryDiagnostics";

import { DispatchContext, initialState, LazyStateContext, reducer, StateContext } from "./reducer";

export function HiddenProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;

    useEffect(() => {
        return registerMemoryStatsProvider("hiddenState", () => {
            const { ids, frozenIds, lastHiddenIds, toggleSnapshot } = lazyValue.current;
            return {
                idCount: ids.size,
                // ids and idArr share one sorted Uint32Array (4 bytes/id).
                // bitsetBytes is 0 until has() builds the lazy membership bitset.
                residentBytes: ids.sortedIds.byteLength,
                maxId: ids.maxId,
                bitsetBytes: ids.bitsetBytes,
                bitsetCapacityBytes: ids.bitsetCapacityBytes,
                frozenCount: frozenIds.size,
                frozenBytes: frozenIds.sortedIds.byteLength,
                frozenMaxId: frozenIds.maxId,
                frozenBitsetBytes: frozenIds.bitsetBytes,
                frozenBitsetCapacityBytes: frozenIds.bitsetCapacityBytes,
                lastHiddenCount: lastHiddenIds.size,
                lastHiddenBytes: lastHiddenIds.sortedIds.byteLength,
                lastHiddenMaxId: lastHiddenIds.maxId,
                lastHiddenBitsetBytes: lastHiddenIds.bitsetBytes,
                lastHiddenBitsetCapacityBytes: lastHiddenIds.bitsetCapacityBytes,
                toggleSnapshotCount: toggleSnapshot.size,
                toggleSnapshotBytes: toggleSnapshot.sortedIds.byteLength,
                toggleSnapshotMaxId: toggleSnapshot.maxId,
                toggleSnapshotBitsetBytes: toggleSnapshot.bitsetBytes,
                toggleSnapshotBitsetCapacityBytes: toggleSnapshot.bitsetCapacityBytes,
            };
        });
    }, []);

    return (
        <StateContext.Provider value={state}>
            <LazyStateContext.Provider value={lazyValue}>
                <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
            </LazyStateContext.Provider>
        </StateContext.Provider>
    );
}
